export const LANGS = [
  { code: "fr", label: "FR" },
  { code: "nl", label: "NL" },
  { code: "en", label: "EN" },
];

export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      stock: "Notre stock",
      on_the_road: "Sur nos routes",
      services: "Services",
      showroom: "Showroom",
      sell: "Vendre / Reprise",
      simulator: "Stage simulateur",
      about: "À propos",
      contact: "Contact",
      admin: "Admin",
      login: "Connexion",
      logout: "Déconnexion",
    },
    hero: {
      discover: "Découvrir le stock",
      sell: "Vendre votre véhicule",
      contact: "Nous contacter",
      scroll: "Découvrir",
    },
    home: {
      services_kicker: "Nos savoir-faire",
      services_title: "Un accompagnement complet",
      featured_kicker: "En vedette",
      featured_title: "Véhicules d'exception",
      featured_view_all: "Voir tout le stock",
      why_kicker: "Pourquoi KV International",
      why_title: "L'exigence a un nom",
      why_1_title: "Sélection rigoureuse",
      why_1_text: "Chaque véhicule est inspecté, son origine certifiée, son historique documenté.",
      why_2_title: "Confiance & transparence",
      why_2_text: "Un seul interlocuteur, un discours clair, aucun compromis sur la qualité.",
      why_3_title: "Livraison en Europe",
      why_3_text: "Nous acheminons votre véhicule où que vous soyez sur le continent.",
      why_4_title: "Financement sur mesure",
      why_4_text: "Solutions de crédit adaptées, en partenariat avec des acteurs de premier rang.",
      testimonials_kicker: "Ils nous font confiance",
      testimonials_title: "Avis clients",
      brands_kicker: "Marques proposées",
      brands_title: "Des icônes automobiles",
      simulator_kicker: "Nouveau — Stage simulateur",
      simulator_title: "Pilotage sur simulateur pro",
      simulator_text: "Trois modules pour dominer la trajectoire, affiner vos réflexes et explorer les limites — sans risque.",
      simulator_cta: "Réserver ma session",
      cta_title: "Un projet, une recherche, une envie ?",
      cta_text: "Notre équipe vous répond dans la journée. Uniquement sur rendez-vous.",
      cta_book: "Prendre rendez-vous",
    },
    services: {
      title: "Nos services",
      subtitle: "De la sélection à la livraison, un accompagnement premium.",
      items: [
        { title: "Achat de véhicules", text: "Rachat direct après check-up complet, aux meilleures conditions du marché." },
        { title: "Vente & mise en dépôt", text: "Vitrine premium et réseau ciblé pour vendre votre voiture au juste prix." },
        { title: "Dépôt-vente", text: "Nous nous occupons de tout : estimation, mise en scène, négociation, transaction." },
        { title: "Reprise", text: "Reprise transparente lors de l'achat de votre prochain véhicule." },
        { title: "Financement", text: "Solutions de crédit sur mesure avec nos partenaires bancaires." },
        { title: "Livraison en Europe", text: "Livraison porte-à-porte, assurance et paperasse incluses." },
        { title: "Recherche personnalisée", text: "Vous cherchez une pièce rare ? Nous la trouvons pour vous." },
        { title: "Conseil premium", text: "Un expert dédié pour vous guider avant, pendant et après l'achat." },
      ],
    },
    simulator: {
      hero_kicker: "Stage de conduite — simulateur professionnel",
      hero_title: "Pilotez au plus haut niveau. Sans user un seul pneu.",
      hero_text: "Développez vos réflexes, votre lecture de trajectoire et votre gestion des transferts de masse sur simulateur dynamique de niveau pro — au cœur de la Belgique.",
      book_btn: "Réserver ma session",
      brochure_btn: "Nous contacter",
      block_kicker: "Programme",
      block_title: "Trois modules pour progresser vite",
      block1_title: "Bloc 1 — Maîtrise technique",
      block1_text: "Contrôlez le transfert de masse, le sous-virage et le survirage. Dominez chaque trajectoire.",
      block2_title: "Bloc 2 — Réflexes de pilote",
      block2_text: "Automatisez vos gestes et affinez le dosage de vos freinages jusqu'au point de rupture de l'adhérence.",
      block3_title: "Bloc 3 — Performance sans risque",
      block3_text: "Explorez les limites physiques de la vitesse — sans user vos pneus, vos freins, ni risquer la moindre casse.",
      benefits_title: "Ce que vous gagnez",
      benefits: [
        "Feedback pilote en temps réel",
        "Analyse télémétrique après chaque session",
        "Simulateur dynamique haut de gamme",
        "Séance individuelle ou en duo",
        "Sur rendez-vous, en soirée ou week-end",
      ],
      cta_title: "Prêt à faire passer votre pilotage au niveau supérieur ?",
      cta_text: "Réservez votre session — nous vous rappelons pour définir votre programme.",
      book_now: "Réserver maintenant",
      book_wa: "WhatsApp",
      book_call: "Appeler",
      book_form: "Formulaire",
      videos_kicker: "En action",
      videos_title: "Le simulateur en vidéo",
      videos_sub: "Un aperçu du rig, des sensations et des sessions type.",
      youtube_kicker: "Vidéos référence",
      youtube_title: "Ce que dit la communauté sim racing.",
      youtube_sub: "Analyses de pilotes pro, démonstrations de rigs dynamiques et sessions d'entraînement — pour comprendre pourquoi le simulateur transforme votre pilotage.",
      reviews_kicker: "Avis de professionnels",
      reviews_title: "Ils l'ont dit avant nous.",
      social_kicker: "Suivez-nous",
      social_title: "Chaque session, chaque véhicule",
      social_text: "Retrouvez les coulisses, les nouveaux véhicules et les sessions simulateur sur nos réseaux.",
    },
    stock: {
      title: "Notre stock",
      subtitle: "Sélection rigoureuse. Origine certifiée. Historique documenté.",
      filters: "Filtres",
      reset: "Réinitialiser",
      brand: "Marque",
      model: "Modèle",
      all: "Toutes",
      price_min: "Prix min (€)",
      price_max: "Prix max (€)",
      year_min: "Année min",
      year_max: "Année max",
      mileage_max: "Km max",
      fuel: "Carburant",
      transmission: "Transmission",
      no_results: "Aucun véhicule ne correspond à ces critères.",
      results: (n) => `${n} véhicule${n > 1 ? "s" : ""}`,
      sort: "Trier par",
      sort_recent: "Plus récents",
      sort_price_asc: "Prix croissant",
      sort_price_desc: "Prix décroissant",
      sort_year_desc: "Année décroissante",
    },
    vehicle: {
      km: "km",
      year: "Année",
      power: "Puissance",
      hp: "ch",
      fuel: "Carburant",
      transmission: "Transmission",
      color: "Couleur",
      warranty: "Garantie",
      months: "mois",
      features: "Équipements principaux",
      description: "Présentation",
      history: "Historique",
      services_included: "Services inclus",
      financing: "Financement disponible",
      delivery: "Livraison en Europe",
      request_info: "Demander des infos",
      book_appt: "Prendre rendez-vous",
      financing_btn: "Simuler un financement",
      back: "Retour au stock",
      share: "Partager",
      status: {
        available: "Disponible",
        reserved: "Réservé",
        sold: "Trop tard",
        sold_full: "Trop tard, déjà sur nos routes",
      },
    },
    about: {
      title: "À propos de KV International",
      subtitle: "Passion, exigence et confiance depuis nos débuts.",
    },
    contact: {
      title: "Nous contacter",
      subtitle: "Uniquement sur rendez-vous. Nous vous répondons rapidement.",
      name: "Nom complet",
      email: "Email",
      phone: "Téléphone",
      subject: "Sujet",
      message: "Votre message",
      send: "Envoyer",
      sent: "Message envoyé. Nous vous recontactons rapidement.",
      request_type: "Type de demande",
      types: {
        general: "Question générale",
        info: "Info véhicule",
        financing: "Financement",
        test_drive: "Prendre rendez-vous",
        sell: "Vendre / dépôt-vente",
        simulator: "Stage simulateur",
      },
      hours: "Horaires",
      address: "Adresse",
      whatsapp: "WhatsApp",
    },
    footer: {
      tagline: "Spécialiste Porsche & véhicules de prestige.",
      nav: "Navigation",
      contact: "Contact",
      legal: "Mentions légales",
      rights: "Tous droits réservés",
    },
    login: {
      title: "Espace administration",
      email: "Email",
      password: "Mot de passe",
      submit: "Se connecter",
      error: "Identifiants invalides",
    },
    admin: {
      dashboard: "Tableau de bord",
      vehicles: "Véhicules",
      testimonials: "Témoignages",
      contacts: "Demandes",
      site: "Contenu du site",
      new: "Nouveau",
      edit: "Modifier",
      delete: "Supprimer",
      save: "Enregistrer",
      cancel: "Annuler",
      confirm_delete: "Confirmer la suppression ?",
      featured: "En vedette",
      status: "Statut",
    },
    common: {
      loading: "Chargement…",
      error: "Une erreur est survenue.",
      required: "Champ requis",
    },
  },

  nl: {
    nav: { home: "Home", stock: "Voorraad", on_the_road: "Op onze wegen", services: "Diensten", showroom: "Showroom", sell: "Verkopen / Inruil", simulator: "Simulator stage", about: "Over ons", contact: "Contact", admin: "Admin", login: "Aanmelden", logout: "Uitloggen" },
    hero: { discover: "Ontdek de voorraad", sell: "Verkoop uw wagen", contact: "Neem contact op", scroll: "Ontdek" },
    home: {
      services_kicker: "Onze expertise", services_title: "Volledige begeleiding",
      featured_kicker: "Uitgelicht", featured_title: "Uitzonderlijke wagens", featured_view_all: "Volledige voorraad",
      why_kicker: "Waarom KV International", why_title: "Uitmuntendheid als standaard",
      why_1_title: "Strenge selectie", why_1_text: "Elk voertuig wordt geïnspecteerd, gecertificeerd en gedocumenteerd.",
      why_2_title: "Vertrouwen & transparantie", why_2_text: "Één aanspreekpunt, duidelijke communicatie, geen compromissen.",
      why_3_title: "Levering in Europa", why_3_text: "Wij leveren uw wagen waar u ook bent in Europa.",
      why_4_title: "Financiering op maat", why_4_text: "Kredietoplossingen aangepast aan uw project.",
      testimonials_kicker: "Zij vertrouwen ons", testimonials_title: "Klantbeoordelingen",
      brands_kicker: "Voorgestelde merken", brands_title: "Automobiel-iconen",
      simulator_kicker: "Nieuw — Simulator stage", simulator_title: "Rijden op pro-simulator",
      simulator_text: "Drie modules om de trajectorie te beheersen, uw reflexen te verfijnen en de limieten te verkennen — zonder risico.",
      simulator_cta: "Reserveer mijn sessie",
      cta_title: "Een project, een zoekopdracht, een verlangen?", cta_text: "Ons team antwoordt dezelfde dag. Enkel op afspraak.",
      cta_book: "Afspraak maken",
    },
    services: {
      title: "Onze diensten", subtitle: "Van selectie tot levering — een premium begeleiding.",
      items: [
        { title: "Aankoop voertuigen", text: "Directe aankoop na volledige check-up, aan de beste marktvoorwaarden." },
        { title: "Verkoop & consignatie", text: "Premium showroom en gericht netwerk om uw wagen aan de juiste prijs te verkopen." },
        { title: "Consignatieverkoop", text: "Wij regelen alles: taxatie, presentatie, onderhandeling, transactie." },
        { title: "Inruil", text: "Transparante inruil bij aankoop van uw volgende wagen." },
        { title: "Financiering", text: "Kredietoplossingen op maat met onze bankpartners." },
        { title: "Levering in Europa", text: "Deur-tot-deur levering met verzekering en administratie." },
        { title: "Persoonlijke zoekopdracht", text: "Zoekt u een zeldzaam exemplaar? Wij vinden het voor u." },
        { title: "Premium advies", text: "Een toegewijde expert vóór, tijdens en na de aankoop." },
      ],
    },
    simulator: {
      hero_kicker: "Rijstage — professionele simulator",
      hero_title: "Rij op topniveau. Zonder één band te verslijten.",
      hero_text: "Ontwikkel uw reflexen, uw lijnkeuze en uw beheer van gewichtsoverdracht op een dynamische pro-simulator — in het hart van België.",
      book_btn: "Reserveer mijn sessie", brochure_btn: "Contact",
      block_kicker: "Programma", block_title: "Drie modules om snel te progresseren",
      block1_title: "Blok 1 — Technische beheersing",
      block1_text: "Beheers gewichtsoverdracht, onderstuur en overstuur. Domineer elke trajectorie.",
      block2_title: "Blok 2 — Piloten-reflexen",
      block2_text: "Automatiseer uw gebaren en verfijn uw remdosering tot aan het breekpunt van de grip.",
      block3_title: "Blok 3 — Prestatie zonder risico",
      block3_text: "Verken de fysieke grenzen van snelheid — zonder banden, remmen of iets anders te verslijten.",
      benefits_title: "Wat u wint",
      benefits: [
        "Real-time coaching feedback",
        "Telemetrie-analyse na elke sessie",
        "Hoogwaardige dynamische simulator",
        "Individueel of in duo",
        "Op afspraak, 's avonds of in het weekend",
      ],
      cta_title: "Klaar om uw rijkunst naar het volgende niveau te tillen?",
      cta_text: "Reserveer uw sessie — wij bellen terug om uw programma op te stellen.",
      book_now: "Reserveer nu", book_wa: "WhatsApp", book_call: "Bellen", book_form: "Formulier",
      videos_kicker: "In actie", videos_title: "De simulator in beeld",
      videos_sub: "Een blik op het rig, de sensaties en typische sessies.",
      social_kicker: "Volg ons", social_title: "Elke sessie, elk voertuig",
      social_text: "Bekijk de coulissen, nieuwe voertuigen en simulator-sessies op onze sociale media.",
    },
    stock: {
      title: "Onze voorraad", subtitle: "Strenge selectie. Gecertificeerde herkomst.",
      filters: "Filters", reset: "Reset", brand: "Merk", model: "Model", all: "Alle",
      price_min: "Min prijs (€)", price_max: "Max prijs (€)", year_min: "Min jaar", year_max: "Max jaar",
      mileage_max: "Max km", fuel: "Brandstof", transmission: "Transmissie",
      no_results: "Geen voertuigen gevonden.", results: (n) => `${n} voertuig${n > 1 ? "en" : ""}`,
      sort: "Sorteer op", sort_recent: "Recentste", sort_price_asc: "Prijs oplopend",
      sort_price_desc: "Prijs aflopend", sort_year_desc: "Jaar aflopend",
    },
    vehicle: {
      km: "km", year: "Jaar", power: "Vermogen", hp: "pk", fuel: "Brandstof",
      transmission: "Transmissie", color: "Kleur", warranty: "Garantie", months: "maanden",
      features: "Belangrijkste uitrusting", description: "Presentatie", history: "Historiek",
      services_included: "Inbegrepen diensten", financing: "Financiering beschikbaar",
      delivery: "Levering in Europa", request_info: "Info aanvragen", book_appt: "Afspraak maken",
      financing_btn: "Financiering simuleren", back: "Terug naar voorraad", share: "Delen",
      status: { available: "Beschikbaar", reserved: "Gereserveerd", sold: "Te laat", sold_full: "Te laat, al op onze wegen" },
    },
    about: { title: "Over KV International", subtitle: "Passie, veeleisendheid en vertrouwen." },
    contact: {
      title: "Contact", subtitle: "Enkel op afspraak. We antwoorden snel.",
      name: "Naam", email: "Email", phone: "Telefoon", subject: "Onderwerp", message: "Uw bericht",
      send: "Versturen", sent: "Bericht verstuurd. We nemen snel contact op.",
      request_type: "Type aanvraag",
      types: { general: "Algemene vraag", info: "Info voertuig", financing: "Financiering", test_drive: "Afspraak maken", sell: "Verkopen / consignatie", simulator: "Simulator stage" },
      hours: "Uren", address: "Adres", whatsapp: "WhatsApp",
    },
    footer: { tagline: "Porsche-specialist & prestigevoertuigen.", nav: "Navigatie", contact: "Contact", legal: "Juridische info", rights: "Alle rechten voorbehouden" },
    login: { title: "Administratie", email: "Email", password: "Wachtwoord", submit: "Aanmelden", error: "Ongeldige gegevens" },
    admin: { dashboard: "Dashboard", vehicles: "Voertuigen", testimonials: "Getuigenissen", contacts: "Aanvragen", site: "Site-inhoud", new: "Nieuw", edit: "Bewerken", delete: "Verwijderen", save: "Opslaan", cancel: "Annuleren", confirm_delete: "Verwijderen bevestigen?", featured: "Uitgelicht", status: "Status" },
    common: { loading: "Laden…", error: "Er is een fout opgetreden.", required: "Verplicht veld" },
  },

  en: {
    nav: { home: "Home", stock: "Inventory", on_the_road: "On the road", services: "Services", showroom: "Showroom", sell: "Sell / Trade-in", simulator: "Simulator Training", about: "About", contact: "Contact", admin: "Admin", login: "Sign in", logout: "Sign out" },
    hero: { discover: "Discover inventory", sell: "Sell your car", contact: "Contact us", scroll: "Explore" },
    home: {
      services_kicker: "Our expertise", services_title: "End-to-end support",
      featured_kicker: "Featured", featured_title: "Exceptional vehicles", featured_view_all: "See full inventory",
      why_kicker: "Why KV International", why_title: "Excellence, by name",
      why_1_title: "Rigorous curation", why_1_text: "Every car is inspected, its origin certified and history documented.",
      why_2_title: "Trust & transparency", why_2_text: "One dedicated contact, clear communication, no compromise.",
      why_3_title: "Europe-wide delivery", why_3_text: "We deliver your car anywhere on the continent.",
      why_4_title: "Tailored financing", why_4_text: "Custom credit solutions with premier banking partners.",
      testimonials_kicker: "They trust us", testimonials_title: "Client reviews",
      brands_kicker: "Featured brands", brands_title: "Automotive icons",
      simulator_kicker: "New — Simulator training", simulator_title: "Pro-grade sim driving",
      simulator_text: "Three modules to master lines, sharpen reflexes and explore the limits — risk-free.",
      simulator_cta: "Book my session",
      cta_title: "A project, a search, a passion?", cta_text: "Our team replies within the day. By appointment only.",
      cta_book: "Book an appointment",
    },
    services: {
      title: "Our services", subtitle: "From sourcing to delivery — a premium experience.",
      items: [
        { title: "Vehicle purchase", text: "Direct buy-out after full check-up at the best market conditions." },
        { title: "Sale & consignment", text: "Premium showroom and targeted network to sell your car at the right price." },
        { title: "Consignment", text: "We handle it all: valuation, staging, negotiation and closing." },
        { title: "Trade-in", text: "Transparent trade-in when buying your next car." },
        { title: "Financing", text: "Tailored credit solutions with our banking partners." },
        { title: "Europe delivery", text: "Door-to-door delivery, insurance & paperwork included." },
        { title: "Bespoke sourcing", text: "Looking for a rare gem? We find it for you." },
        { title: "Premium advisory", text: "A dedicated expert before, during and after the purchase." },
      ],
    },
    simulator: {
      hero_kicker: "Driving stage — professional simulator",
      hero_title: "Drive at the highest level. Without wearing a single tyre.",
      hero_text: "Develop reflexes, racing-line reading and weight-transfer control on a professional dynamic simulator — in the heart of Belgium.",
      book_btn: "Book my session", brochure_btn: "Contact us",
      block_kicker: "Programme", block_title: "Three modules to progress fast",
      block1_title: "Block 1 — Technical mastery",
      block1_text: "Master weight transfer, understeer and oversteer. Own every line.",
      block2_title: "Block 2 — Driver reflexes",
      block2_text: "Automate inputs and refine braking modulation to the very edge of grip.",
      block3_title: "Block 3 — Performance risk-free",
      block3_text: "Explore the physical limits of speed — no tyre, no brake, no crash wear.",
      benefits_title: "What you gain",
      benefits: [
        "Real-time coaching feedback",
        "Telemetry analysis after each session",
        "High-end dynamic simulator",
        "Solo or duo sessions",
        "By appointment, evenings or weekends",
      ],
      cta_title: "Ready to take your driving to the next level?",
      cta_text: "Book your session — we call you back to define the programme.",
      book_now: "Book now", book_wa: "WhatsApp", book_call: "Call", book_form: "Form",
      videos_kicker: "In action", videos_title: "The simulator in motion",
      videos_sub: "A glimpse at the rig, the sensations and typical sessions.",
      social_kicker: "Follow us", social_title: "Every session, every car",
      social_text: "Discover behind-the-scenes, new cars and simulator sessions on our socials.",
    },
    stock: {
      title: "Inventory", subtitle: "Rigorous curation. Certified origin. Documented history.",
      filters: "Filters", reset: "Reset", brand: "Brand", model: "Model", all: "All",
      price_min: "Min price (€)", price_max: "Max price (€)", year_min: "Min year", year_max: "Max year",
      mileage_max: "Max km", fuel: "Fuel", transmission: "Transmission",
      no_results: "No vehicles match your criteria.", results: (n) => `${n} vehicle${n > 1 ? "s" : ""}`,
      sort: "Sort by", sort_recent: "Most recent", sort_price_asc: "Price ↑",
      sort_price_desc: "Price ↓", sort_year_desc: "Year ↓",
    },
    vehicle: {
      km: "km", year: "Year", power: "Power", hp: "hp", fuel: "Fuel",
      transmission: "Transmission", color: "Colour", warranty: "Warranty", months: "months",
      features: "Key features", description: "Overview", history: "History",
      services_included: "Included services", financing: "Financing available",
      delivery: "Europe delivery", request_info: "Request info", book_appt: "Book appointment",
      financing_btn: "Simulate financing", back: "Back to inventory", share: "Share",
      status: { available: "Available", reserved: "Reserved", sold: "Too late", sold_full: "Too late — already on the road" },
    },
    about: { title: "About KV International", subtitle: "Passion, standards, trust." },
    contact: {
      title: "Contact us", subtitle: "By appointment only. Fast replies.",
      name: "Full name", email: "Email", phone: "Phone", subject: "Subject", message: "Your message",
      send: "Send", sent: "Message sent. We'll be in touch shortly.",
      request_type: "Request type",
      types: { general: "General enquiry", info: "Vehicle info", financing: "Financing", test_drive: "Book appointment", sell: "Sell / consignment", simulator: "Simulator training" },
      hours: "Hours", address: "Address", whatsapp: "WhatsApp",
    },
    footer: { tagline: "Porsche specialist & prestige vehicles.", nav: "Navigate", contact: "Contact", legal: "Legal", rights: "All rights reserved" },
    login: { title: "Admin area", email: "Email", password: "Password", submit: "Sign in", error: "Invalid credentials" },
    admin: { dashboard: "Dashboard", vehicles: "Vehicles", testimonials: "Testimonials", contacts: "Requests", site: "Site content", new: "New", edit: "Edit", delete: "Delete", save: "Save", cancel: "Cancel", confirm_delete: "Confirm deletion?", featured: "Featured", status: "Status" },
    common: { loading: "Loading…", error: "Something went wrong.", required: "Required" },
  },
};

export const BRANDS = ["Porsche", "Bentley", "Lamborghini", "Ferrari", "Mercedes-Benz", "BMW", "Audi", "Aston Martin", "McLaren", "Land Rover", "Alpine", "Nissan"];
